import React from 'react';
import { Box } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { boxStyles } from '../../constants/styles';

interface Props {
  testId?: string;
  rowsCount?: number;
}

const renderRows = (rowsCount: number, index: number) => {
  const isLastRow = index === rowsCount - 1;
  const isFourthRow = index === 3;
  const isFifthRow = index === 4;

  return (
    <SkeletonLoaderWrapper>
      <SkeletonLoader width="20%" marginRight="40px" marginBottom={isLastRow ? '0' : undefined} />
      <SkeletonLoader
        width="20%"
        marginBottom={isLastRow ? '0' : undefined}
        height={isFourthRow || isFifthRow ? '100px' : undefined}
      />
    </SkeletonLoaderWrapper>
  );
};

/**
 * CollapsibleSummaryLoader component is used to render the loader for the collapsible summary grid section.
 * Usually used in the order details and invoice details pages.
 * @param {string} testId - testId for the component.
 * @param {number} rowsCount - number of rows in the collapsible summary grid.
 */
export const CollapsibleSummaryLoader = ({ testId = 'collapsible-summary-loader', rowsCount = 7 }: Props) => {
  return (
    <div data-testid={testId}>
      <Box padding="space.250" xcss={boxStyles} paddingBlockStart="space.200">
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="24px" />
          <SkeletonLoader width="20%" />
        </SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          {/* Bottom border */}
          <SkeletonLoader width="100%" height="1px" />
        </SkeletonLoaderWrapper>
        {Array.from({ length: rowsCount }).map((_, index) => renderRows(rowsCount, index))}
      </Box>
    </div>
  );
};
